import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { APP_LANGUAGE } from '../../core/app-language';
import { ToggleClassService } from './../../service/toggle/toggle-class.service';
import { AuthService } from '../../service/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  url:string = ''
  buttonActive:string = ''

  CTNredirect:boolean = false

  private subscriptions: Array<Subscription> = [];
  role:string = ''

  // Multi-language — disabled until re-enabled (see commented block below and header template)
  // public activeLang = 'es';
  // defaultLn = { lan: 'es', id: 'es', flag: '/assets/img/flags/es.png' }
  // languajes:any[] = [
  //   { lan: 'Es', id: 'es', flag: '/assets/img/flags/es.png' },
  //   { lan: 'Pt', id: 'pt', flag: '/assets/img/flags/br.png' },
  //   { lan: 'En', id: 'en', flag: '/assets/img/flags/us.png' },
  // ]

  public constructor(
    public toggleService: ToggleClassService,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
  ) {
    let role = JSON.parse(localStorage.getItem('role') || '{}') as string
    this.role = role
    this.lockLanguage()
    // this.checkLanguaje()
    // this.homeSrv.changeLng()
    this.subscriptions.push(
      this.router.events.subscribe((val) => {
        val instanceof NavigationEnd && ( this.url = String(this.router.url.split('/')[1]))
        this.url = String(this.router.url.split('/')[1])
      })
    )
    this.getButtonActive()
    this.listenCTNredirect()
  }

  private lockLanguage(): void {
    localStorage.setItem('languaje', APP_LANGUAGE);
    this.translate.setDefaultLang(APP_LANGUAGE);
    this.translate.use(APP_LANGUAGE);
  }

  listenCTNredirect(){
    this.authService.getCTNRedirect().subscribe((value:boolean) => {
      this.CTNredirect = value 
    })
  }

  // getLang(ln:string){
  //   this.homeSrv.getLanguage(ln)
  //   .then((res:any) => {
  //     localStorage.setItem('languaje', ln);
  //     localStorage.setItem('languageData', JSON.stringify(res.data))
  //     this.homeSrv.changeLng()
  //   })
  //   .catch((err:any) => {
  //     console.log(err)
  //   })
  // }

  ngOnInit(): void {
   
  }
  getButtonActive(){
    this.subscriptions.push(
      this.toggleService.getButtonActive().subscribe(btnActive => {
        this.buttonActive = btnActive
      } )
    )   
  }

  // checkLanguaje(){
  //   let languaje = localStorage.getItem('languaje') || 'es'
  //   this.activeLang = languaje
  //   this.translate.use(languaje)
  //   this.defaultLn = this.languajes.find(flag => flag.id === languaje )
  // }

  // changeLanguaje(flag:any){
  //   localStorage.setItem('languaje', flag.id)
  //   this.activeLang = flag.id
  //   this.translate.use(flag.id)
  //   this.defaultLn = flag
  //   this.getLang(flag.id)
  // }

  redirectURL(route:string){
    this.router.navigate([route]).then(success => {
      success && this.toggleService.setButtonActive(route);
    });
  }

  logout(){
    this.authService.doLogout();
    if(this.CTNredirect){
      window.location.href = ''
    }
    this.router.navigate(['pages/login-master'])
  }

}
